import React from 'react';
import PropTypes from 'prop-types';

import { FixtureLinkButton } from './FixtureLinkButton';

import { getTranslation } from 'common/react/utils/translations';
import { useGetContentQuery } from 'store/modules/api/content-api';

export const FixtureMatchReportLink = ({ match, reportLabel }) => {
    const requestConfig = {
        type: 'TEXT',
        params: {
            pageSize: 1,
            references: `AFL_MATCH:${match.id}`,
            tagNames: `match-report`
        }
    };

    const { data: matchReport } = useGetContentQuery(requestConfig);

    if (matchReport?.content.length) {
        const compAbbr = PULSE.app.common.match.getCompName(
            match.compSeason.providerId
        );
        const matchReportLink = PULSE.app.common.url.getMatchURL(
            match,
            reportLabel
        );

        return (
            <FixtureLinkButton
                href={PULSE.app.common.url.getMatchURL(match.id, reportLabel)}
                icon="report"
                label={getTranslation('label.fixtures.match-report')}
                theme="alt"
                onClick={() => {
                    PULSE.app.tracking.selectFixtureCardCtaHandler(
                        getTranslation('label.fixtures.match-report'),
                        matchReportLink,
                        moment(match?.utcStartTime).format('dddd MMMM D'),
                        PULSE.app.common.url.isExternalUrl(matchReportLink),
                        compAbbr.toLowerCase()
                    );
                }}
            />
        );
    }

    return <></>;
};

FixtureMatchReportLink.propTypes = {
    match: PropTypes.object.isRequired,
    reportLabel: PropTypes.string
};
